import { Component, Input, OnDestroy, Renderer2, SecurityContext, ViewChild } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-custom-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.css']
})
export class TooltipComponent implements OnDestroy {
  @Input() tooltipInfo: string = "Default tooltip info";
  @Input() tooltipTitle: string = "Default tooltip title";
  @ViewChild(MatTooltip) tooltip: MatTooltip;

  private observer: MutationObserver | null = null;

  constructor(
    private renderer: Renderer2,
    private sanitizer: DomSanitizer
  ) { }

  ngAfterViewInit() {
    this.setTooltipCustomStyle();
  }

  /* 
    Estiliza tool tip de Angular Material con custom HTML.
    A penas se detecte la aparición de un elemento nuevo que tenga como children
    un elemento con clase 'mdc-tooltip__surface', setea property innerHTML a ese elemento
  */
  ngOnDestroy() {
    this.observer?.disconnect();
    this.observer = null;
  }

  private setTooltipCustomStyle() {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node: Node) => {
          if (node instanceof HTMLElement) {
            const tooltipElement = node.querySelector('.mdc-tooltip__surface');
            if (tooltipElement) {
              this.updateTooltipInnerHTML(tooltipElement);
            }
          }
        });
      });
    });

    this.observer.observe(document.body, { childList: true, subtree: true });
  }

  private updateTooltipInnerHTML(tooltipElement: Element) {
    const sanitizedTooltipTitle = this.sanitizer.sanitize(SecurityContext.HTML, this.tooltipTitle);
    const sanitizedTooltipInfo = this.sanitizer.sanitize(SecurityContext.HTML, this.tooltipInfo);
    (tooltipElement as HTMLElement).style.overflow = 'visible';
    tooltipElement.innerHTML = `
      <div style="position: relative;">
        <div style="position: absolute; top: 0px; right: 0px; cursor: pointer;" id="close-tooltip">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFF">
            <path d="M480-451.69 270.15-241.85q-5.61 5.62-13.77 6-8.15.39-14.53-6-6.39-6.38-6.39-14.15 0-7.77 6.39-14.15L451.69-480 241.85-689.85q-5.62-5.61-6-13.77-.39-8.15 6-14.53 6.38-6.39 14.15-6.39 7.77 0 14.15 6.39L480-508.31l209.85-209.84q5.61-5.62 13.77-6 8.15-.39 14.53 6 6.39 6.38 6.39 14.15 0 7.77-6.39 14.15L508.31-480l209.84 209.85q5.62 5.61 6 13.77.39 8.15-6 14.53-6.38 6.39-14.15 6.39-7.77 0-14.15-6.39L480-451.69Z"/>
          </svg>
        </div>
        <div style="font-weight: bold; font-size: 1.125em; line-height: 24px;">
          ${sanitizedTooltipTitle}
        </div>
       ${sanitizedTooltipInfo}
      </div>
      <div style="position: absolute;top:96%;left:43.5%;">
        <svg width="26" height="8" viewBox="0 0 26 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.5858 6.58481L5.87868 0.877703C5.31607 0.315094 4.55301 -0.000976562 3.75736 -0.000976562H22.2426C21.447 -0.000976562 20.6839 0.315093 20.1213 0.877702L14.4142 6.58481C13.6332 7.36586 12.3668 7.36586 11.5858 6.58481Z" fill="#0C122D"/>
        <path d="M0 0.499023H3.34315C4.40401 0.499023 5.42143 0.920451 6.17157 1.6706L10.8787 6.37771C12.0503 7.54928 13.9497 7.54928 15.1213 6.3777L19.8284 1.6706C20.5786 0.92045 21.596 0.499023 22.6569 0.499023H26" stroke="#0C122D"/>
        </svg>
      </div>
    `;
    // Add event listener to "X" sign
    const closeTooltipButton = tooltipElement.querySelector('#close-tooltip');
    if (closeTooltipButton) {
      this.renderer.listen(closeTooltipButton, 'click', () => {
        this.tooltip.hide();
      });
    }
  }


}